export default __webpack_public_path__ + "static/media/steve_work_2.c700f429.png";